import React from 'react';

const BookmarksRouteNavigationOptions = {
  title: 'Bookmarks',
  headerTitle: () => null,
};

export default BookmarksRouteNavigationOptions;
